import { type FunctionComponent } from 'react'

import SearchSuggestionName from 'views/components/organisms/SearchBox/SearchBoxListItem/SearchSuggestionName'

const PopularCategoriesOrBrands: FunctionComponent<{
  listItems: { name: string; url: string }[]
  title: string
}> = ({ listItems, title }) =>
  listItems ? (
    <div className="o-SearchBox__popular-categories-or-brands u-padding--right@small-tiny">
      <div className="u-padding--right@medium o-SearchBox__top-searches-product__wrapper">
        <div className="o-SearchBox__top-searches-product__title u-font-weight--bold">
          {title}
        </div>
        <ul className="a-list-reset u-padding--top o-SearchBox__top-searches__list-item__list">
          {[...listItems]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(({ name, url }, index) => (
              <li
                className="u-padding-xx-small--ends o-SearchBox__top-searches__list-item__wrapper"
                key={index}
              >
                <a
                  className="a-link"
                  href={url}
                  data-clientside-hook="SearchBoxListSuggestBrandLink"
                >
                  <span className="o-SearchBox__label">
                    <SearchSuggestionName name={name} />
                  </span>
                </a>
              </li>
            ))}
        </ul>
      </div>
    </div>
  ) : null

export default PopularCategoriesOrBrands
